import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Link } from 'react-router-dom';

import { useSelector } from 'react-redux';

import LoginIcon from '../../common/icons/LoginIcon';
import UserIcon from '../../common/icons/UserIcon';
import MenuIcon from '../../common/icons/MenuIcon';

import { LogoWhite, LogoBlack } from '../../common/icons/Logos';

const TransparentHeader = props => {
  const { isAuthenticated } = useSelector(state => state);

  const isPrimary = props.isPrimary || false;

  const linkClassNames = classnames('desktop-menu-link', { 'is-secondary': !isPrimary });
  const iconClassNames = classnames('desktop-menu-icon', { 'is-secondary': !isPrimary });

  return (
    <nav className={classnames('desktop-menu', { 'is-secondary': !isPrimary })}>
      <div className="desktop-menu-container tutorium-container">
        <div className="is-flex align-items-center">
          <div className="desktop-menu-burger" onClick={props.openSidebar}>
            <MenuIcon className={iconClassNames} />
          </div>
          <Link to="/" className="is-flex">
            {isPrimary ? <LogoWhite /> : <LogoBlack />}
          </Link>
          <span className="ml-20px tag is-light">Admin</span>
        </div>
        <div className=" is-flex is-fullheight">
          {isAuthenticated && (
            <Link to="/profile" className={linkClassNames}>
              <UserIcon size={30} className={iconClassNames} />
            </Link>
          )}
          {!isAuthenticated && (
            <Link to="/auth" className={linkClassNames}>
              <div className="is-flex align-items-center">
                <span className="mr-10px">Sign In</span>
                <LoginIcon className={iconClassNames} />
              </div>
            </Link>
          )}
        </div>
      </div>
    </nav>
  );
};

TransparentHeader.propTypes = {
  openSidebar: PropTypes.func.isRequired,
  isPrimary: PropTypes.bool,
};

export default TransparentHeader;
